import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../components/auth/PrivateRoute';
import { LandingPage, LoginForm, AppHome } from '../lazyComponents';

/** Public shell and authenticated app home. */
export function CorePublicAppRoutes() {
  return (
    <>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginForm />} />
      <Route
        path="/app"
        element={
          <PrivateRoute>
            <AppHome />
          </PrivateRoute>
        }
      />
    </>
  );
}
